"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = validateOrganisation;

function validateOrganisation(organisationState, requiredFields) {
  return requiredFields.every(function (field) {
    if (typeof field === 'string') {
      return Boolean(organisationState[field]);
    }

    var fieldName = field.fieldName,
        key = field.key;
    return Boolean(organisationState[fieldName]) && Boolean(organisationState[fieldName][key]);
  });
}